import React from 'react';
import { View } from 'react-native';
import { ActivityIndicator } from 'react-native-paper';

import { flex } from '../../style-utils';

export type CenteredLoadingProps = React.ComponentProps<
  typeof ActivityIndicator
>;

export const CenteredLoading: React.FC<CenteredLoadingProps> = ({
  size,
  style,
  ...props
}) => (
  <View style={[flex('align-content-center', 'justify-content-center'), style]}>
    <ActivityIndicator size={size} {...props} />
  </View>
);
